import { mapCookieConsent } from "./cookiebot-utils";
const isCookieBotEnabled = "false";

let cookiebotConsentListenerAdded = false;

function addScript({ src, attributes }) {
  return new Promise((resolve, reject) => {
    const scriptElement = document.createElement("script");
    scriptElement.src = src;
    scriptElement.type = "text/javascript";

    attributes.forEach(({ name, value }) => {
      scriptElement.setAttribute(name, value);
    });

    scriptElement.onload = () => {
      console.log("Script loaded:", src);
      resolve();
    };

    scriptElement.onerror = () => {
      console.error("Script failed to load:", src);
      reject(new Error(`Script failed to load: ${src}`));
    };

    document.head.appendChild(scriptElement);
  });
}

function onCookiebotConsentReady(app) {
  if (!window.Cookiebot) {
    return console.warn("Cookiebot not available");
  }

  if (cookiebotConsentListenerAdded) {
    return console.log("Consent event listener already added");
  }

  window.addEventListener("CookiebotOnConsentReady", () => {
    const { consent } = window.Cookiebot;

    window.Shopify?.customerPrivacy?.setTrackingConsent(
      {
        analytics: consent.statistics,
        marketing: consent.marketing,
        preferences: consent.preferences,
        sale_of_data: consent.marketing, // Mapping sale_of_data to marketing
        headlessStorefront: true,
        checkoutRootDomain: "checkout.snooze.com.au",
        storefrontRootDomain: "www.snooze.com.au",
        storefrontAccessToken: "374948ed8143715d901bb66f8ffc0ba7",
      },
      () => console.log("Consent captured")
    );

    app.$gtm.gtag("consent", "update", {
      ad_personalization: consent.marketing ? "granted" : "denied",
      ad_storage: consent.marketing ? "granted" : "denied",
      ad_user_data: consent.marketing ? "granted" : "denied",
      analytics_storage: consent.statistics ? "granted" : "denied",
      functionality_storage: consent.preferences ? "granted" : "denied",
      personalization_storage: consent.preferences ? "granted" : "denied",
      security_storage: "granted",
    });

    cookiebotConsentListenerAdded = true;
  });
}

export default (options, inject) => {
  const { app } = options;
  const scriptsToLoad = [
    {
      src: "https://consent.cookiebot.com/uc.js",
      attributes: [
        { name: "hid", value: "cookiebot-api" },
        { name: "data-cbid", value: "f7ea49a5-fd72-470c-9945-087e2aaaad00" },
        { name: "data-blockingmode", value: "auto" },
      ],
    },
    {
      src: "https://cdn.shopify.com/shopifycloud/consent-tracking-api/v0.1/consent-tracking-api.js",
      attributes: [{ name: "hid", value: "cookie-consent-api" }],
      defer: true,
    },
  ];

  if (isCookieBotEnabled == "true") {
    Promise.all(scriptsToLoad.map(addScript))
      .then(() => onCookiebotConsentReady(app))
      .catch(err => console.error("Error loading scripts:", err));
  }

  inject("cookieConsent", {
    showBanner() {
      if (window.Cookiebot) {
        window.Cookiebot.show();
        console.info("Cookiebot consent banner explicitly opened");
      } else {
        console.error("Cookiebot is not loaded");
      }
    },

    isConsented(category) {
      if (isCookieBotEnabled == "false") {
        return true;
      }
      if (!category) {
        return false;
      }
      const { consent } = window.Cookiebot || {};
      return category.split(",").every(cat => consent?.[mapCookieConsent(cat)]);
    },

    waitForCookiebotLoad() {
      return new Promise(resolve => {
        if (window.Cookiebot || isCookieBotEnabled == "false") {
          setTimeout(resolve, 0);
        } else {
          const interval = setInterval(() => {
            if (window.Cookiebot) {
              clearInterval(interval);
              setTimeout(resolve, 0);
            }
          }, 50);
        }
      });
    },
  });
};
